const state = {
  isMobile: false
}

const getters = {
  isMobile: (state) => {
    return state.isMobile
  }
}

const mutations = {
  setIsMobile(state, newValue) {
    state.isMobile = newValue
  }
}

const actions = {
  setIsMobile({ commit }, newValue) {
    commit('setIsMobile', newValue)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}